import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import TeamCard from '../../Reusable/TeamCard';
import brush_img from "../../../assets/images/brush.png"
import { axiosInstance } from '../config';

const TeamMembers = () => {

    const settings = {
        dots: true,
        fade: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        waitForAnimate: false,
        arrows: false,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const [data, setData] = useState([])

    useEffect(() => {
        window.scrollTo(0, 0)
        getCustomersInfo()
    }, [])

    function getCustomersInfo() {
        axiosInstance.get(`staff`)
            .then(res => {
                setData(res?.data?.Staff.reverse())
            })
            .catch((err) => console.log(err))
            .finally(() => {
            })
    }

    return (
        <div className="rs-team team-style1 gray-bg pt-120 pb-120 md-pt-80">
            <div className="container">
                <div className="sec-title2 text-center mb-0 mb-xl-5">
                    <div className="brush-content center-text mb-20">
                        <img src={brush_img} alt="" />
                        <span className="sub-text">Team Members</span>
                    </div>
                    <h2 className="title">
                        Meet Our Team of Expert
                        <br />
                        Cleaning Staff
                    </h2>
                </div>

                <div className='team-member'>
                    <Slider {...settings} >
                        {data?.map((obj, i) => {
                            return (
                                <TeamCard name={obj?.name} image={obj?.imageUrl} position={obj?.position} id={i} key={i} />
                            )
                        })}
                    </Slider>
                </div>

            </div>
        </div>

    )
}

export default TeamMembers